// https://dev.darum.ng/warehouse-service/api/v1/bins?rackId=ds&rackName=sd&productId=ds&binName=ds&binType=ds&page=0&size=10

export const composeTableFilterUri = (
  tblUri: string,
  searchQuery: string,
  filter: string
) => {
  switch (filter) {
    case 'warehouseId':
      tblUri = `${tblUri}&warehouseId=${searchQuery}`;
      break;
    case 'enabled':
      tblUri = `${tblUri}&enabled=${searchQuery}`;
      break;
    case 'binCount':
      tblUri = `${tblUri}&binCount=${searchQuery}`;
      break;
    case 'lastUpdatedDate':
      tblUri = `${tblUri}&lastUpdatedDate=${searchQuery}`;
      break;
    case 'createdBy':
      tblUri = `${tblUri}&createdBy=${searchQuery}`;
      break;
    case 'createdDate':
      tblUri = `${tblUri}&createdDate=${searchQuery}`;
      break;
    case 'productId':
      tblUri = `${tblUri}&productId=${searchQuery}`;
      break;
    case 'binName':
      tblUri = `${tblUri}&binName=${searchQuery}`;
      break;
  }
  return tblUri;
};
